import { render } from "./AnswersSurvey.vue?vue&type=template&id=5aef67fb&scoped=true"
import script from "./AnswersSurvey.vue?vue&type=script&lang=js"
export * from "./AnswersSurvey.vue?vue&type=script&lang=js"

import "./AnswersSurvey.vue?vue&type=style&index=0&id=5aef67fb&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aef67fb"]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading});
